import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import freelancerLandingImg from "../../../assets/images/freelancerLandingPage.png";
import fastTime from "../../../assets/images/fast-time.png";
import calender from "../../../assets/images/calendar.png";
import jobSearchImg from "../../../assets/images/job-search 2.png";
import quotesImg from "../../../assets/images/quotes.svg";
import userImg from "../../../assets/images/user-freelancer.svg";
// import { Pagination } from "swiper/core";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import { Pagination, Navigation } from "swiper/modules";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Layout from "../../components/Layout/Layout";
import { setPortalInfo } from "../../../redux/globalSlice";
import "./index.scss";

const Freelancer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const portal = localStorage.getItem("portal");

  const handleNavigation = () => {
    dispatch(
      setPortalInfo({
        portalName: "Freelancer",
        portalValue: "freelancer",
      })
    );
    navigate("/login");
  };
  return (
    <>
      <Layout>
        <section className="freelancer-header-section">
          <div className="fhs-left-section">
            <div className="ls-small-heading">
              <p>Are You looking For</p>
            </div>
            <div className="ls-heading">
              <h1>Extra Earning,</h1>
            </div>
            <div className="ls-subheading">
              <h3>
                Start Working With <span>Octahire</span>
              </h3>
            </div>
            <div className="ls-paragraph">
              <p>
                Join the OctaHire team as a freelancer, share your network to
                earn more, and get your candidates hired in just a few steps
              </p>
            </div>
            {(!token || (token && portal === "Freelancer")) && (
              <div className="ls-btn">
                <button type="button" onClick={() => handleNavigation()}>
                  Start Now
                </button>
              </div>
            )}
          </div>
          <div className="fhs-right-section">
            <img src={freelancerLandingImg} alt="smiling-young-businessmen" />
          </div>
          {(!token || (token && portal === "Freelancer")) && (
            <div className="ls-btn-mobile">
              <button type="button" onClick={() => handleNavigation()}>
                Start Now
              </button>
            </div>
          )}
        </section>
        <section className="key-feature-section">
          <Container>
            <div className="kfs-heading">
              <h3>Key Feature</h3>
              <p>
                Reach out to millions of jobseekers and hire quickly with our
                fast and easy job posting services.
              </p>
            </div>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={4} className="kfs-grid">
                <div className="kfs-card">
                  <div className="card-content">
                    <img src={fastTime} alt="" />
                    <h4>2 Minutes to Post</h4>
                    <p>
                      Quick and easy job posting with screening questions to get
                      filtered candidates
                    </p>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="kfs-grid">
                <div className="kfs-card">
                  <div className="card-content">
                    <img src={jobSearchImg} alt="" />
                    <h4>Attract Audience</h4>
                    <p>Attract Audience from across the country</p>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="kfs-grid">
                <div className="kfs-card">
                  <div className="card-content">
                    <img src={calender} alt="" />
                    <h4>Get 30 days visibility</h4>
                    <p>
                      Get free visibility for portal and its features for
                      initial 30 days.
                    </p>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Container>
        </section>

        <Box className="end-section">
          <Container>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <Box className="end-section-content">
                  <h3>Review & Testimonial</h3>
                </Box>

                <Swiper
                  spaceBetween={24}
                  slidesPerView={3}
                  className="mySwiper"
                  pagination={{
                    clickable: true,
                  }}
                  navigation={{
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                  }}
                  breakpoints={{
                    320: {
                      slidesPerView: 1,
                      spaceBetween: 10,
                    },
                    640: {
                      slidesPerView: 1,
                      spaceBetween: 10,
                    },
                    768: {
                      slidesPerView: 3,
                      spaceBetween: 20,
                    },
                    1024: {
                      slidesPerView: 3,
                      spaceBetween: 20,
                    },
                  }}
                  modules={[Pagination, Navigation]}
                >
                  <Box className="banner-img-section">
                    <SwiperSlide>
                      <Box className="swiper-card">
                        <img className="top-img" src={quotesImg} alt="img" />
                        <p className="card-main-content">
                          We have built a network of trusted freelancers we can
                          depend on when we need something done.
                        </p>
                        <Box className="id-location">
                          <img src={userImg} alt="img" />
                          <div className="id-name-content">
                            <p>Vikas Kumar</p>
                            <p>Indore,M.P</p>
                          </div>
                        </Box>
                      </Box>
                    </SwiperSlide>
                    <SwiperSlide>
                      <Box className="swiper-card">
                        <img className="top-img" src={quotesImg} alt="img" />
                        <p className="card-main-content">
                          We have built a network of trusted freelancers we can
                          depend on when we need something done.
                        </p>
                        <Box className="id-location">
                          <img src={userImg} alt="img" />
                          <div className="id-name-content">
                            <p>Vikas Kumar</p>
                            <p>Indore,M.P</p>
                          </div>
                        </Box>
                      </Box>
                    </SwiperSlide>
                    <SwiperSlide>
                      <Box className="swiper-card">
                        <img className="top-img" src={quotesImg} alt="img" />
                        <p className="card-main-content">
                          We have built a network of trusted freelancers we can
                          depend on when we need something done.
                        </p>
                        <Box className="id-location">
                          <img src={userImg} alt="img" />
                          <div className="id-name-content">
                            <p>Vikas Kumar</p>
                            <p>Indore,M.P</p>
                          </div>
                        </Box>
                      </Box>
                    </SwiperSlide>
                    <SwiperSlide>
                      <Box className="swiper-card">
                        <img className="top-img" src={quotesImg} alt="img" />
                        <p className="card-main-content">
                          We have built a network of trusted freelancers we can
                          depend on when we need something done.
                        </p>
                        <Box className="id-location">
                          <img src={userImg} alt="img" />
                          <div className="id-name-content">
                            <p>Vikas Kumar</p>
                            <p>Indore,M.P</p>
                          </div>
                        </Box>
                      </Box>
                    </SwiperSlide>
                    <SwiperSlide>
                      <Box className="swiper-card">
                        <img className="top-img" src={quotesImg} alt="img" />
                        <p className="card-main-content">
                          We have built a network of trusted freelancers we can
                          depend on when we need something done.
                        </p>
                        <Box className="id-location">
                          <img src={userImg} alt="img" />
                          <div className="id-name-content">
                            <p>Vikas Kumar</p>
                            <p>Indore,M.P</p>
                          </div>
                        </Box>
                      </Box>
                    </SwiperSlide>
                  </Box>
                  <div className="swiper-button-prev"></div>
                  <div className="swiper-button-next"></div>
                </Swiper>
              </Grid>
            </Grid>
          </Container>
        </Box>
      </Layout>
    </>
  );
};

export default Freelancer;
